// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/app/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/app/src/pages/index.js"),
  "component---src-pages-profile-js": require("gatsby-module-loader?name=component---src-pages-profile-js!/app/src/pages/profile.js"),
  "component---src-pages-the-burning-glass-js": require("gatsby-module-loader?name=component---src-pages-the-burning-glass-js!/app/src/pages/the-burning-glass.js"),
  "component---src-pages-windermere-js": require("gatsby-module-loader?name=component---src-pages-windermere-js!/app/src/pages/windermere.js"),
  "component---src-pages-works-js": require("gatsby-module-loader?name=component---src-pages-works-js!/app/src/pages/works.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/app/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/app/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/app/.cache/json/index.json"),
  "profile.json": require("gatsby-module-loader?name=path---profile!/app/.cache/json/profile.json"),
  "the-burning-glass.json": require("gatsby-module-loader?name=path---the-burning-glass!/app/.cache/json/the-burning-glass.json"),
  "windermere.json": require("gatsby-module-loader?name=path---windermere!/app/.cache/json/windermere.json"),
  "works.json": require("gatsby-module-loader?name=path---works!/app/.cache/json/works.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/app/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/app/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js